import React, { Component } from 'react'
import { Button, Form, Input, Upload, Icon, Select, Switch } from 'antd'
import {connect} from 'dva'
import {Link} from 'dva/router'
import { message } from 'antd'
import config from '../../utils/config'
import InputMask from 'react-input-mask';
import { all, create, get } from '../../services/restApi'
import PropTypes from 'prop-types'
var IconAwesome = require('react-fontawesome');
const _ = require('underscore')

const FormItem = Form.Item;
const Option = Select.Option;

class ReceptionistNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            imageUrl: '',
            file: {},
            loading: false,
            receptionist: {},
            hotels: []
        }

        if (localStorage.getItem('currentHotel')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        if (this.props.params.receptionistId) {
            this.props.dispatch({type: 'app/showLoading'})

            get('_User', this.props.params.receptionistId, {include: 'hotels'}).then((resp) => {

                if (resp.hotels && resp.hotels.length > 0) {
                    let hotels = []
                    resp.hotels.map((item, key) => {
                        hotels.push({ key: item.objectId, label: item.name });

                        if (key === resp.hotels.length - 1) {
                            resp.hotels = hotels;
                        }
                    })
                }

                this.props.form.setFieldsValue(resp);
                this.setState({ receptionist: resp });

                if (resp.picture) {
                    this.setState({ imageUrl: config.externalUrl + 'uploads/users/' + resp.picture });
                }
                this.props.dispatch({type: 'app/hideLoading'})
            })
        }

        // Query
        let query = {};
        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            //if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: resp.results[0].objectId, label: resp.results[0].name}});
            this.setState({
                hotels: resp.results
            });
        })
    }


    /**
    * Codifica la imagen al formato Base64
    */
    getBase64 (img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }


    /**
    * Validación antes de subir la imagen
    */
    beforeUpload (file) {
        const isJPEG = file.type === 'image/jpeg';
        const isJPG = file.type === 'image/jpg';
        const isPNG = file.type === 'image/png';
        if (!isJPG && !isJPEG && !isPNG) {
            message.error('El formato de la imagen is inválido!');
        }

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('La imagen debe ser menor a 2MB!');
        }

        this.setState({file: file, loading: true});
        return (isJPG || isJPEG || isPNG) && isLt2M;
    }


    /**
    * Visualiza la imagen preview subida
    */
    handlePictureChange (info) {
        if (info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => this.setState({ imageUrl }));
            this.setState({loading: false});
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Validator: Checa el username sin espacios
    */
    checkUsername (rule, value, callback) {
        if (value && /\s/.test(value)) {
            callback('Verifique que el usuario no contenga espacios!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa el correcto formato del teléfono
    */
    checkPhone (rule, value, callback) {
        if (value && value.replace(/[^\d.]/g, '').length < 10) {
            callback('Por favor, ingrese un número de teléfono válido!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        //if (value && !value.label) {
        if (value && value.length === 0) {            
            callback('Por favor, elija al menos un hotel');
        } else {
            callback();
        }
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            if (values.phone)
                values.phone = values.phone.replace(/[^\d.]/g, '');

            if (values.mobile_phone)
                values.mobile_phone = values.mobile_phone.replace(/[^\d.]/g, '');

            if (this.state.file.uid)
                values.picture = this.state.file.uid + '.jpg';
            
            if (!this.props.params.receptionistId) {
                // CREA

                // Model
                let data = {...values};
                data.type = 'recepcionista';
                data.hotels = [];
                data.active = true;

                values.hotels.map(item => {
                    data.hotels.push({ __type: 'Pointer', className: 'Hotel', objectId: item.key });
                })

                data = _.omit(data, ['hotel']);

                this.props.dispatch({type: 'app/showButtonLoading'})
                create('_User', data).then(resp => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el receptionista exitosamente');

                    this.props.form.resetFields();
                    this.props.form.setFieldsValue({phone: '', mobile_phone: ''})
                    this.setState({imageUrl: ''})

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                /*_.extend(this.state.receptionist, {
                    ...values, 
                    hotel: {...values.hotels, name: values.hotels.label} 
                });*/

                let data = {...values};
                data.objectId = this.state.receptionist.objectId;
                data.hotels = [];

                values.hotels.map(item => {
                    data.hotels.push({ __type: 'Pointer', className: 'Hotel', objectId: item.key, name: item.label });
                })
                data = _.omit(data, ['hotel']);

                this.props.dispatch({type: 'receptionist/update', payload: data})
                this.context.router.goBack();
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link to="/all_users/list-receptionists"><i className="fa fa-arrow-circle-left"></i></Link>
                        Receptionista
                    </h1>
                </section>

                <section className="content">
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Datos del Nuevo Receptionista
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    {this.props.params.receptionistId
                                        ? <div className="col-md-12">
                                            Status: <FormItem hasFeedback>
                                                {this.props.form.getFieldDecorator('active')(
                                                    <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={this.props.form.getFieldValue('active')} />
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }
                                    
                                    <div className="col-md-2">
                                        <label>Foto de perfil <small>(opcional)</small></label>
                                        <Upload
                                            className="avatar-uploader"
                                            name="file"
                                            accept="image/*"
                                            showUploadList={true}
                                            action={config.externalUrl + "includes/upload.php"}
                                            beforeUpload={this.beforeUpload.bind(this)}
                                            onChange={this.handlePictureChange.bind(this)}
                                            headers={{
                                                "X-Parse-Application-Id": config.appId
                                            }}
                                            data={{
                                                type: 'user',
                                                custom_name: this.state.file.uid + '.jpg'
                                            }}
                                        >
                                            {this.state.imageUrl ?
                                                <img src={this.state.imageUrl} alt="" className="avatar" /> :
                                                this.state.loading ? 
                                                    <IconAwesome name="refresh" spin className="spin-uploader" />
                                                    : <Icon type="plus" className="avatar-uploader-trigger" />
                                            }
                                        </Upload>
                                    </div>

                                    <div className="col-md-10">
                                        { this.state.receptionist && !this.state.receptionist.objectId
                                            ? <div>
                                                <div className="col-md-4">
                                                    <FormItem label="Usuario" hasFeedback>
                                                        {this.props.form.getFieldDecorator('username', {
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, ingrese el nombre de usuario'
                                                            }, {
                                                                validator: this.checkUsername.bind(this)
                                                            }]
                                                        })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                                    </FormItem>
                                                </div>

                                                <div className="col-md-4">
                                                    <FormItem label="Contraseña" hasFeedback>
                                                        {this.props.form.getFieldDecorator('password', {
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, ingrese la contraseña'
                                                            }]
                                                        })(<Input type="password" size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                                    </FormItem>
                                                </div>
                                            </div>
                                            : ''
                                        }

                                        <div className="col-md-4">
                                            <FormItem label="Nombre completo" hasFeedback>
                                                {this.props.form.getFieldDecorator('name', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese el nombre del receptionista'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Correo electrónico" hasFeedback>
                                                {this.props.form.getFieldDecorator('email', {
                                                    rules: [{
                                                        type: 'email',
                                                        required: true,
                                                        message: 'Por favor, ingrese el correo electrónico del receptionista'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Teléfono" hasFeedback>
                                                {this.props.form.getFieldDecorator('phone', {
                                                    rules: [{
                                                        required: false,
                                                    }, {
                                                        validator: this.checkPhone.bind(this)
                                                    }]
                                                })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Celular" hasFeedback>
                                                {this.props.form.getFieldDecorator('mobile_phone', {
                                                    rules: [{
                                                        required: false,
                                                        message: 'Por favor, ingrese el teléfono celular del receptionista'
                                                    }, {
                                                        validator: this.checkPhone.bind(this)
                                                    }]
                                                })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Hoteles que administra" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotels', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, elija al menos un hotel'
                                                    }]
                                                })(
                                                    <Select 
                                                        size='large'
                                                        mode="tags"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                    </div>
                                </div>

                                <div className="row text-center">
                                    <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </section>
            </div>
        )
    }
}

ReceptionistNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({receptionist, app}) => ({receptionist, app}))(Form.create()(ReceptionistNew))


// WEBPACK FOOTER //
// ./src/components/receptionists/receptionistNew.js